'use strict';

angular.module('schoolbushubApp')
    .factory('School', function ($resource, DateUtils) {
        return $resource('api/schools/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'filterQuery': { method: 'POST', url: 'api/schools/query', isArray:true },
            'filterVars': { method: 'GET', url: 'api/schools/info', isArray:true },
            'update': { method:'PUT' }
        });
    });
